import {
  CHANGE_ACTIVE_NAV,
  CHANGE_ACTIVE_SCHOOL,
  CHANGE_SELECTED_ADDRESS_FROM_MARKER,
  CHANGE_SELECTED_ROUTE,
  IS_FINISH_FETCH_OPTIMISATION_ROUTE,
  REHYDRATE_NAV_DATA,
  UPDATE_ROUTE_TIME_DATA,
} from "./navmode.type";

export const changeActiveNav = (mode: string) => ({
  type: CHANGE_ACTIVE_NAV,
  payload: {
    mode,
  },
});

export const changeActiveSchool = (school: object) => ({
  type: CHANGE_ACTIVE_SCHOOL,
  payload: {
    school,
  },
});

export const rehydrateNavData = () => ({
  type: REHYDRATE_NAV_DATA,
});

export const changeSelectedRoute = (route: object) => ({
  type: CHANGE_SELECTED_ROUTE,
  payload: {
    route,
  },
});

export const changeSelectedAddressFromMarker = (address_changes: object) => ({
  type: CHANGE_SELECTED_ADDRESS_FROM_MARKER,
  payload: {
    address_changes,
  },
});

export const updateRouteTimeData = (route_time_data: object) => ({
  type: UPDATE_ROUTE_TIME_DATA,
  payload: {
    route_time_data,
  },
});

export const changeIsFinishFetchOptimisationRoute = (
  is_finish_fetch_optimisation_route: boolean,
) => ({
  type: IS_FINISH_FETCH_OPTIMISATION_ROUTE,
  payload: {
    is_finish_fetch_optimisation_route: is_finish_fetch_optimisation_route,
  },
});
